/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ScanBarcodeClassicIcon16Solid = forwardRef('ScanBarcodeClassicIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M3 3a1 1 0 0 0-2 0v10a1 1 0 1 0 2 0V3Z" }),
        React.createElement("path", { d: "M5 2a1 1 0 0 1 1 1v7.5a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1Z" }),
        React.createElement("path", { d: "M9.002 3a1 1 0 1 0-2 0v10a1 1 0 1 0 2 0V3Z" }),
        React.createElement("path", { d: "M11.003 2a1 1 0 0 1 1 1v7.5a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1Z" }),
        React.createElement("path", { d: "M14.004 2a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1Z" })));
});
